import React from 'react';
import Select from './Select';

const EmployeeSelect = ({ options = [], value = null, onChange = () => {},  isLoading = false, disabled = false }) => {
  return (
    <Select
      placeholder="salesFilters.Employee"
      options={options}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      disabled={disabled}
      idKey="id"
      labelKey="label"
      returnObject={true}
      isSearchable
    />
  );
};

export default EmployeeSelect;